import React, { ReactNode } from 'react'
import { Col, Row } from 'react-bootstrap'
import { MeetingScoreInsights } from './MeetingScoreInsights'
import { StructuredCategory } from './model'
import { ReactComponent as Rise } from '../../../../../assets/images/rise.svg'

export interface MeetingScorecardSectionProps {
  scoreResult: StructuredCategory<any>
  meetingScoreItems: ReactNode
  type: string
  icon: ReactNode
  description: string
}

export const MeetingScorecardSection: React.FC<MeetingScorecardSectionProps> = ({ scoreResult, meetingScoreItems, type, icon, description }) => {
  return (
    <Col className='d-flex zocks-p-2.0 flex-column align-items-start zocks-mb-3 ms-5 zocks-border-1.0 score-container'>
      <Row className='align-items-center zocks-gap-0.75'>
        <Col className='p-0' xs='auto'>
          <div className='d-flex justify-content-center align-items-center gap-2 zocks-border-0.25 zocks-bg-color-gray-900 icon-wrapper'>{icon}</div>
        </Col>
        <Col className='p-0'>
          <h5 className='mb-0 zocks-text-gray-900'>{type} Score</h5>
        </Col>
      </Row>
      <Row className='mt-3'>
        <div className='p-0'>{description}</div>
      </Row>
      <Row className='gap-3 zocks-mt-3 mb-3'>
        <MeetingScoreInsights scoreInsights={scoreResult.strength} insightType='Strengths' icon={<i className='bi bi-trophy zocks-text-gray-900'></i>} />
        <MeetingScoreInsights scoreInsights={scoreResult.improve} insightType='Areas to improve' icon={<Rise></Rise>} />
      </Row>
      {meetingScoreItems}
    </Col>
  )
}
